import { PopperPlacementType } from '@mui/material';
import { StyledPopper } from '../../menu/Popper/Popper';
import { LinkButton } from '../../link/LinkButton';

interface FilterContentPopperProps {
  target: string;
  open: boolean;
  placement?: PopperPlacementType;
  className?: string;
  children: React.ReactNode;
  title: string;
  clearFilter: VoidFunction;
}

export function FilterContentPopper({
  target,
  open,
  placement = 'right',
  children,
  className = '',
  title,
  clearFilter
}: FilterContentPopperProps) {
  return (
    <StyledPopper
      dataId={target.replace('#', '')}
      className={className}
      target={target}
      open={open}
      placement={placement}
    >
      <div className='border-bottom px-3 pt-1 pb-2 center-flex-row justify-between'>
        <p className='text-body-3 text-secondary'>{title}</p>
        <LinkButton size='md' dataId={`${target.replace('#', '')}-clear`} onClick={clearFilter}>
          Clear
        </LinkButton>
      </div>
      {children}
    </StyledPopper>
  );
}
